// extracted by mini-css-extract-plugin
export default {"menuBlock":"XE-z","title":"YE-z","nav":"ZE-z","flexCell":"_E-z","facetLink":"aF-z"};